import { render, staticRenderFns } from "./IconSpaces.vue?vue&type=template&id=98c7a7fa"
import script from "./IconSpaces.vue?vue&type=script&lang=js"
export * from "./IconSpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports